import { getSession } from '../../services/session.service';
import { NextApiRequest, NextApiResponse } from 'next';

// export const config = {
//   api: {
//     externalResolver: true,
//   },
// };

async function handler(req: NextApiRequest, res: NextApiResponse) {
  try {
    const session = await getSession(req, res);
    console.log('session', session, req.headers);
    res.status(200).send(session);
  } catch (error) {
    return res.status(422).send({
      message: 'Unable to get the session',
      error,
    });
  }
}

export default handler;
